import axios from '../plugins/axios'

export default {
    all(){
      return axios.get('/api/v1/pr_settings/fb_pixels')
    },
    update({ fb_pixels}){
      return axios.post('/api/v1/pr_settings/fb_pixel/update', {
        fb_pixels: fb_pixels
      })
    },
}
